/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { uploadImages } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  reimbursementTxnRequest,
  reimbursementTxnRequestApproval,
} from "../../../../redux/features/reimbursementTransaction";

import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import ICONS from "../../../../assets/Icons";
import SelectAccount from "../../../../components/ReimbursementTxn/SelectAccount";
import TransferAmount from "../../../../components/ReimbursementTxn/TransferAmount";
import AdditionalDetails from "../../../../components/ReimbursementTxn/AdditionalDetails";
import TxnConfirm from "../../../../components/ReimbursementTxn/TxnConfirm";
import AmountToWords from "../../../../components/_utils/AmountToWords";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import { toast } from "react-toastify";
import CommonToast from "../../../../components/_utils/CommonToast";
import { reimbursementTxnViewAll } from "../../../../redux/features/reimbursementTransaction";

const ReimburseCreateTxn = () => {
  const steps = [
    "Source and destination account",
    "Additional details and labels",
    "Transfer amount",
    "Confirm and create",
  ];

  const scrollIt = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentAccountDetails = location?.state;

  const categories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const { beneTxnAccountData, beneTxnAccountLoading } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  const type = location?.state?.type;
  const flow = location?.state?.flow;
  const TypeRTGS = location?.state?.TypeRTGS;

  const [createActive, setCreateActive] = useState(false);
  const [files, setFiles] = useState([]);
  const [endDate, setEndDate] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});

  const [isStepper, setIsStepper] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  const [isNeft, setIsNeft] = useState(
    currentAccountDetails?.amount < GlobalConfiguration?.settleTypeValue
      ? true
      : false,
  );
  const [isRtgs, setIsRtgs] = useState(
    currentAccountDetails?.amount > GlobalConfiguration?.settleTypeValue
      ? true
      : false,
  );
  const [isImps, setIsImps] = useState(false);
  const [quantity, setQuantity] = useState({});
  const [timeData, setTimeData] = useState({});
  const [catShow, setCatShow] = useState(false);
  const [startDate, setStartDate] = useState({});
  const [mapingCat, setMapingCat] = useState("");
  const [activeStep, setActiveStep] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [txnLoading, settxnLoading] = useState(false);
  const [showSimilarModal, setShowSimilarModal] = useState(false);
  const [similarTransaction, setSimilarTransaction] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [showImages, setShowImages] = useState("");
  const [hyperLinks, setHyperLinks] = useState({});
  const [quantities, setQuantities] = useState({});
  const [refreshId, setRefreshId] = useState(true);
  const [labelsAcc, setLabelsAcc] = useState(null);
  const [direction, setDirection] = useState(null);
  const [catSelect, setCatSelect] = useState(false);
  const [openOwner, setOpenOwner] = useState(false);
  const [selectBank, setSelectBank] = useState(false);
  const [startDateCal, setStartDateCal] = useState({});
  const [showYearDrop, setShowYearDrop] = useState({});
  const [smallSearch, setSmallSearch] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amountInWords, setAmountInWords] = useState("");
  const [selectedValue, setSelectedValue] = useState({});
  const [RefactorFlow, setRefactorFlow] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState({});
  const [additionalData, setAdditionalData] = useState();
  const [accountSelect, setAccountSelect] = useState(false);
  const [selectSortAmt, setSelectSortAmt] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [showRupeeSymbol, setShowRupeeSymbol] = useState(false);
  const [showDatePickerCal, setShowDatePickerCal] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(
    currentAccountDetails?.selectedCategory ?? null,
  );
  const [dateRangeEnabled, setDateRangeEnabled] = useState(false);
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [isConnectedSelected, setIsConnectedSelected] = useState(true);
  const [selectBankNonActive, setSelectBankNonActive] = useState(false);
  const [transactionFilterData, setTransactionFilterData] = useState([]);
  const [isSingleDateSelected, setIsSingleDateSelected] = useState(false);
  const [smallSearchNonActive, setSmallSearchNonActive] = useState(false);
  const [selectedValueName, setselectedValueName] = useState("username" || "");
  const [initialRefactorAdditionalDetail, setInitialRefactorAdditionalDetail] =
    useState({});
  const [copyData, setCopyData] = useState({
    title: "",
    data_type: "",
    value: "",
  });
  const [filterPayload, setFilterPayload] = useState({
    pagination: GlobalConfiguration.lengthCheckZero,
    accNoInput: "",
    currentPage: GlobalConfiguration.lengthCheckOne,
    sortBank: "",
    sortAccountNo: "",
    bankNameInput: "",
    currentPageText: "01",
    beneAccountSearch: "",
    searchTerm: "",
  });
  const [filterPayloadNonActive, setFilterPayloadNonActive] = useState({
    pagination: GlobalConfiguration.lengthCheckZero,
    accNoInput: "",
    currentPage: GlobalConfiguration.lengthCheckOne,
    sortBank: "",
    sortAccountNo: "",
    bankNameInput: "",
    currentPageText: "01",
    searchTerm: "",
  });

  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: currentAccountDetails?.bankAccountName
      ? currentAccountDetails.bankAccountName
      : currentAccountDetails?.name
        ? currentAccountDetails?.name
        : "",
    beneAccountId: currentAccountDetails?.beneAccountId
      ? currentAccountDetails?.beneAccountId
      : currentAccountDetails?.id
        ? currentAccountDetails?.id
        : "",
    bankAccountIFSC: currentAccountDetails?.bankAccountIFSC
      ? currentAccountDetails?.bankAccountIFSC
      : currentAccountDetails?.ifsc_code
        ? currentAccountDetails?.ifsc_code
        : "",
    bankAccountNo: currentAccountDetails?.bankAccountNo
      ? currentAccountDetails?.bankAccountNo
      : currentAccountDetails?.bank_acc_no
        ? currentAccountDetails?.bank_acc_no
        : "",
    categories: currentAccountDetails?.categories
      ? currentAccountDetails?.categories
      : currentAccountDetails?.category
        ? currentAccountDetails?.category
        : "",
    amount: currentAccountDetails?.amount,
    settleType: currentAccountDetails?.amount
      ? Number(currentAccountDetails.amount) >
        Number(GlobalConfiguration?.settleTypeValue)
        ? "rtgs"
        : "neft"
      : "",
    bankLogo: currentAccountDetails?.bankLogo
      ? currentAccountDetails?.bankLogo
      : "",
    pan: currentAccountDetails?.pan ? currentAccountDetails?.pan : "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: GlobalConfiguration.lengthCheckZero,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: currentAccountDetails?.selectedCategory
      ? currentAccountDetails?.selectedCategory
      : null,
    mergeCategory: currentAccountDetails?.mergeCategory ?? null,
    amountInWords: currentAccountDetails?.amountInWords ?? "",
    labels: currentAccountDetails?.labels ? currentAccountDetails?.labels : [],
    ownerLabels: [],
    comment: "",
    date: currentAccountDetails?.date
      ? new Date(currentAccountDetails?.date)
      : "",
    expenseType: currentAccountDetails?.expenseType ?? "",
    description: currentAccountDetails?.description ?? "",
    uploadFile: currentAccountDetails?.uploadFile ?? "",
    uploadURL: currentAccountDetails?.uploadURL,
  });
  const [NewAmount, setNewAmount] = useState(
    currentAccountDetails?.amount || "",
  );
  const [category, setCategory] = useState(
    txnPayLoad?.categories ? txnPayLoad?.categories?.split(",") : [],
  );
  const [openBar, setOpenBar] = useState(false);

  const initialAmount = Number(
    currentAccountDetails?.amount || GlobalConfiguration.lengthCheckZero,
  );
  const enteredAmount = Number(
    txnPayLoad?.amount || GlobalConfiguration.lengthCheckZero,
  );

  const isStepValidRequest = !currentAccountDetails?.amount
    ? true
    : enteredAmount <= initialAmount;

  const formatDate = (date) => {
    return `${date.getDate()}/${date.getMonth() < GlobalConfiguration.panLength ? `0${date.getMonth() + GlobalConfiguration.lengthCheckOne}` : date.getMonth() + GlobalConfiguration.lengthCheckOne}/${date.getFullYear()}`;
  };

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const getAmountInWords = (amount) => {
    const numericValue = amount?.replace(/[^0-9.]/g, "") || "";
    const amountNumber = parseFloat(numericValue);

    if (numericValue.trim() === "" || isNaN(amountNumber)) return "";

    const words = AmountToWords(amountNumber);
    return amountNumber > GlobalConfiguration.lengthCheckZero &&
      amountNumber <= GlobalConfiguration.lengthCheckOne
      ? words.replace("rupees", "rupee")
      : words;
  };

  const handleKeyDown = (event) => {
    if (
      event.target.tagName === "INPUT" ||
      event.target.tagName === "TEXTAREA"
    ) {
      if (event.key === "Tab") {
        event.preventDefault();
      }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab"
    ) {
      event.preventDefault();
    }
  };

  const isAmountValid =
    txnPayLoad?.amount > GlobalConfiguration.lengthCheckZero;

  const isRtgsSelected =
    type === "PayReimburseTxn"
      ? txnPayLoad?.amount > GlobalConfiguration.settleTypeValue
      : txnPayLoad?.settleType === "rtgs";

  const isSettleTypeValid =
    txnPayLoad?.settleType &&
    !(
      (txnPayLoad?.settleType === "imps" &&
        txnPayLoad?.amount > GlobalConfiguration.settleTypeValue) ||
      (txnPayLoad?.settleType === "rtgs" &&
        txnPayLoad?.amount <= GlobalConfiguration.settleTypeValue) ||
      (txnPayLoad?.settleType === "neft" &&
        txnPayLoad?.amount > GlobalConfiguration.settleTypeValue)
    );

  let isStepValid = false;

  const isRtgsValid =
    !isRtgsSelected ||
    txnPayLoad?.amount >= GlobalConfiguration.settleTypeValue;

  const handleCreateTransaction = async () => {
    try {
      setCreateActive(true);

      let haveImage = txnPayLoad?.mergeCategory?.some(
        (val) => val?.data_type === "upload" && val?.value !== "Not Given",
      );

      let storeData;

      console.log("FINAL PAYLOAD", storeData);
      let add = GlobalConfiguration.lengthCheckZero;
      let fileUpload;
      if (type !== "PayReimburseTxn") {
        fileUpload = await dispatch(uploadImages(txnPayLoad.uploadFile));
      }

      if (haveImage) {
        const responseUpload = await Promise.all(
          Object.values(uploadedFiles).map((file) =>
            dispatch(uploadImages(file)),
          ),
        );

        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];

            if (val?.data_type === "from_year_to_year") {
              return {
                ...val,
                value: {
                  from: dataValue?.from ? Number(dataValue.from) : null,
                  to: dataValue?.to ? Number(dataValue.to) : null,
                },
              };
            }

            if (val?.data_type === "numeric") {
              const integerValue = parseInt(dataValue, 10);
              if (isNaN(integerValue)) {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for '${val?.name}'`,
                );
              }
              return { ...val, value: integerValue };
            }

            if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            }

            if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            }

            return { ...val, value: dataValue };
          }

          if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }

          return val;
        });
      } else {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData?.[val?.name]) {
            const dataValue = additionalData[val?.name];

            if (val?.data_type === "from_year_to_year") {
              return {
                ...val,
                value: {
                  from: dataValue?.from ? Number(dataValue.from) : null,
                  to: dataValue?.to ? Number(dataValue.to) : null,
                },
              };
            }

            if (val?.data_type === "numeric") {
              const integerValue = parseInt(dataValue, 10);
              if (isNaN(integerValue)) {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for '${val?.name}'`,
                );
              }
              return { ...val, value: integerValue };
            }

            if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            }

            return { ...val, value: dataValue };
          }

          if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }

          return val;
        });
      }
      let response1;

      if (type !== "PayReimburseTxn") {
        response1 = await dispatch(
          reimbursementTxnRequest({
            expense_type: txnPayLoad.expenseType,
            amount: txnPayLoad.amount,
            beneficiary_account_id: txnPayLoad.beneAccountId,
            reimbursement_date: formatDate(new Date(txnPayLoad.date)),
            uploaded_file_data: fileUpload?.payload,
            category: selectedCategory?.name,
            additional_data: storeData,
            labels: [
              ...(txnPayLoad.labels || []),
              ...(txnPayLoad.ownerLabels || []),
            ],
            description: txnPayLoad?.description,
            payment_method: txnPayLoad.settleType.toUpperCase(),
            comment: txnPayLoad?.comment,
          }),
        );

        if (response1?.error) {
          setCreateActive(false);
          navigate(
            "/reimbursement_transaction_dashboard/create_reimbursement_transactions_txn/failed",
            {
              replace: true,
            },
          );
          return;
        }
      }
      const response2 = await dispatch(
        reimbursementTxnRequestApproval({
          request_id:
            type === "PayReimburseTxn"
              ? currentAccountDetails?.request_id
              : response1?.payload?.request?.[0]?.request_id,
          reimbursement_amount: txnPayLoad.amount,
          owner_account_id: txnPayLoad.ownerId,
          comments: txnPayLoad.comment,
          payment_method: txnPayLoad.settleType.toUpperCase(),
        }),
      );

      if (response2?.error?.message !== "Rejected") {
        const transactionId =
          type === "PayReimburseTxn"
            ? currentAccountDetails?.request_id
            : response1?.payload?.request?.[0]?.request_id;

        navigate(
          `/reimbursement_transaction_dashboard/create_reimbursement_transactions_txn/success/${transactionId}`,
          {
            replace: true,
            state: {
              type: type === "PayReimburseTxn" ? "PayReimburseTxn" : "",
              Request_id: currentAccountDetails?.request_id,
            },
          },
        );
      } else {
        navigate(
          "/reimbursement_transaction_dashboard/create_reimbursement_transactions_txn/failed",
          {
            replace: true,
          },
        );
      }
    } catch (error) {
      navigate(
        "/reimbursement_transaction_dashboard/create_reimbursement_transactions_txn/failed",
        {
          replace: true,
        },
      );
    } finally {
      setCreateActive(false);
    }
  };

  const queryParams = () => ({
    page_no: GlobalConfiguration?.lengthCheckOne,
    page_item_count: PaginationConfiguration?.paginationSmall,
    amount: txnPayLoad?.amount,
    payment_method: txnPayLoad?.settleType?.toUpperCase(),
    beneficiary_account_id: txnPayLoad?.beneAccountId,
    owner_account_id: txnPayLoad?.ownerId,
  });

  const handleNext = async () => {
    if (isButtonDisabled) return;
    setButtonDisabled(true);
    try {
      if (activeStep === GlobalConfiguration.lengthCheckTwo) {
        settxnLoading(true);
        const res = await dispatch(reimbursementTxnViewAll(queryParams()));
        const hasDuplicates =
          res?.payload?.transactions?.length >
          GlobalConfiguration?.lengthCheckZero;

        setSimilarTransaction(hasDuplicates);

        if (hasDuplicates) {
          toast.dismiss();
          CommonToast({
            text: "Few issues found click check to view.",
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        } else {
          toast.dismiss();
          CommonToast({
            text: "No issues found.",
            icon: ICONS.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        setActiveStep((prev) => prev + GlobalConfiguration.lengthCheckOne);
        settxnLoading(true);
        setDirection("next");
        setRemoveClassName(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setOpenBar(false);
      } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
        if (similarTransaction) {
          setShowSimilarModal(true);
        } else {
          await handleCreateTransaction();
        }
      } else {
        setActiveStep((prev) => prev + GlobalConfiguration.lengthCheckOne);

        setDirection("next");

        setRemoveClassName(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setTimeout(() => {
          setButtonDisabled(false);
        }, IntervalConfiguration?.intervalSmaller);
        setOpenBar(false);
      }
    } finally {
      setButtonDisabled(false);
    }
  };

  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };

  const handleAmountChange = (data) => {
    const { name, value } = data;

    if (value[0] !== GlobalConfiguration.lengthCheckZero) {
      const numericValue = value.replace(/[^0-9.]/g, "");

      if (name === "amount") {
        if (
          allowedValue(numericValue) ||
          numericValue.length === GlobalConfiguration.lengthCheckZero
        ) {
          const amountNumber = parseFloat(numericValue);
          const amountWords =
            numericValue.trim() === "" ? "" : AmountToWords(amountNumber);

          const adjustedAmountWords =
            amountNumber >= GlobalConfiguration.lengthCheckOne &&
            amountNumber <= GlobalConfiguration.accountnormalLength
              ? amountWords.replace("rupees", "rupee")
              : amountWords;

          setTxnPayLoad((prevState) => ({
            ...prevState,
            amount: numericValue,
            amountInWords: adjustedAmountWords,
          }));

          setShowRupeeSymbol(numericValue.trim() !== "");
          setAmountInWords(adjustedAmountWords);
        }
      }
    }
  };

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[GlobalConfiguration.lengthCheckZero],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[GlobalConfiguration.lengthCheckOne],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[GlobalConfiguration.lengthCheckTwo],
    },
    {
      previousText: "Previous",
      nextText: similarTransaction ? "Check" : "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: similarTransaction
        ? "var(--emphasis)"
        : "var(--positive-act)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !createActive,
      stepperText: steps[GlobalConfiguration.accountminLength],
    },
  ];

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  const renderCreateTxn = () => {
    switch (activeStep) {
      case GlobalConfiguration.lengthCheckZero:
        return (
          <SelectAccount
            catName={beneTxnAccountData?.transaction?.[0]?.category}
            setCatShow={setCatShow}
            catSelect={catSelect}
            setCatSelect={setCatSelect}
            accountSelect={accountSelect}
            setAccountSelect={setAccountSelect}
            mapingCat={mapingCat}
            category={category}
            setCategory={setCategory}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            handleCategorySelect={handleCategory}
            categories={categories}
            BenEnableNextButton={BenEnableNextButton}
            setAdditionalData={setAdditionalData}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            setSelectedValue={setSelectedValue}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setShowDatePicker={setShowDatePicker}
            setDateRangeEnabled={setDateRangeEnabled}
            setShowDatePickerCal={setShowDatePickerCal}
            setStartDateCal={setStartDateCal}
            setIsSingleDateSelected={setIsSingleDateSelected}
            setQuantities={setQuantities}
            setAmountInWords={setAmountInWords}
            setHyperLink={setHyperLinks}
            setPreviewImages={setPreviewImages}
            setUploadedFiles={setUploadedFiles}
            setTimeData={setTimeData}
            setMapingCat={setMapingCat}
            setLabelsAcc={setLabelsAcc}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            flow={flow === "PayReimburseTxn" ? flow : "reimbursement"}
            type={type}
            TypeRTGS={TypeRTGS}
            currentAccountDetails={currentAccountDetails}
          />
        );
      case GlobalConfiguration.lengthCheckOne:
        return (
          <AdditionalDetails
            catShow={catShow}
            setCatShow={setCatShow}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            handleCategorySelect={handleCategory}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            BenEnableNextButton={BenEnableNextButton}
            nextButtonEnabled={nextButtonEnabled}
            activeStep={activeStep}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            showDatePicker={showDatePicker}
            setShowDatePicker={setShowDatePicker}
            dateRangeEnabled={dateRangeEnabled}
            setDateRangeEnabled={setDateRangeEnabled}
            showDatePickerCal={showDatePickerCal}
            setShowDatePickerCal={setShowDatePickerCal}
            startDateCal={startDateCal}
            setStartDateCal={setStartDateCal}
            isSingleDateSelected={isSingleDateSelected}
            setIsSingleDateSelected={setIsSingleDateSelected}
            quantities={quantities}
            setQuantities={setQuantities}
            files={files}
            setFiles={setFiles}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
            showImages={showImages}
            setShowImages={setShowImages}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            showRupeeSymbol={showRupeeSymbol}
            setShowRupeeSymbol={setShowRupeeSymbol}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            timeData={timeData}
            setTimeData={setTimeData}
            copyData={copyData}
            setCopyData={setCopyData}
            handleAmountChange={handleAmountChange}
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
            setQuantity={setQuantity}
            quantity={quantity}
            setShowYearDrop={setShowYearDrop}
            showYearDrop={showYearDrop}
            type={type}
          />
        );
      case GlobalConfiguration.lengthCheckTwo:
        return (
          <TransferAmount
            selectBank={selectBank}
            setSelectBank={setSelectBank}
            filterPayload={filterPayload}
            setFilterPayload={setFilterPayload}
            filterPayloadNonActive={filterPayloadNonActive}
            setFilterPayloadNonActive={setFilterPayloadNonActive}
            smallSearch={smallSearch}
            setSmallSearch={setSmallSearch}
            selectSortAmt={selectSortAmt}
            setSelectSortAmt={setSelectSortAmt}
            isConnectedSelected={isConnectedSelected}
            setIsConnectedSelected={setIsConnectedSelected}
            BenEnableNextButton={BenEnableNextButton}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isNeft={isNeft}
            setIsNeft={setIsNeft}
            isRtgs={isRtgs}
            setIsRtgs={setIsRtgs}
            isImps={isImps}
            setIsImps={setIsImps}
            transactionFilterData={transactionFilterData}
            setTransactionFilterData={setTransactionFilterData}
            refreshId={refreshId}
            setRefreshId={setRefreshId}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            selectBankNonActive={selectBankNonActive}
            setSelectBankNonActive={setSelectBankNonActive}
            smallSearchNonActive={smallSearchNonActive}
            setSmallSearchNonActive={setSmallSearchNonActive}
            activeStep={activeStep}
            RefactorFlow={RefactorFlow}
            setRefactorFlow={setRefactorFlow}
            labelsAcc={labelsAcc}
            showRupeeSymbol={showRupeeSymbol}
            setShowRupeeSymbol={setShowRupeeSymbol}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
            copyData={copyData}
            setCopyData={setCopyData}
            selectedValueName={selectedValueName}
            setselectedValueName={setselectedValueName}
            NewAmount={NewAmount}
            setNewAmount={setNewAmount}
            type={type}
            currentAccountDetails={currentAccountDetails}
            isStepValid={isStepValidRequest}
            RequestAmountWords={getAmountInWords}
            isRtgsValid={isRtgsValid}
            txnLoading={txnLoading}
          />
        );
      case GlobalConfiguration.accountminLength:
        return (
          <TxnConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            handleCategorySelect={handleCategory}
            categories={categories}
            additionalData={additionalData}
            amountInWords={txnPayLoad.amountInWords}
            files={files}
            showImages={showImages}
            uploadedFiles={uploadedFiles}
            previewImages={previewImages}
            flow={flow}
            showSimilarModal={showSimilarModal}
            setShowSimilarModal={setShowSimilarModal}
            queryParams={queryParams()}
            onForceCreate={handleCreateTransaction}
          />
        );
      default:
        return null;
    }
  };

  const handleBack = () => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      navigate(-1);
    } else {
      setActiveStep((prevActiveStep) =>
        prevActiveStep
          ? prevActiveStep - GlobalConfiguration.lengthCheckOne
          : GlobalConfiguration.lengthCheckZero,
      );
      setDirection("previous");
      setRemoveClassName(false);
      settxnLoading(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration.intervalMedium);

      setOpenBar(false);
    }
  };

  const handleCategory = (selectedCategoryData) => {
    setSelectedCategory(selectedCategoryData);
  };

  useEffect(() => {
    if (!beneTxnAccountLoading) {
      const initalData = {};

      const additionalData =
        beneTxnAccountData?.transaction?.[0]?.additional_data?.data || [];

      additionalData?.forEach(({ name, value, data_type }) => {
        if (
          value !== null &&
          value !== "" &&
          value !== undefined &&
          value?.length !== GlobalConfiguration?.lengthCheckZero
        ) {
          if (
            data_type === "hyperlink" ||
            data_type === "string" ||
            data_type === "numeric"
          ) {
            initalData[name] = {
              isCopyClick: false,
              isPaste: {},
              name: name,
              data: value,
            };
          } else {
            initalData[name] = {
              isCopyDirect: false,
              name: name,
              data: value,
            };
          }
        }
      });
      setInitialRefactorAdditionalDetail(initalData);
    }
  }, [beneTxnAccountData, beneTxnAccountLoading]);

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];

    const mandatoryFields = configData.filter((val) => val?.mandatory === "Y");
    const filledMandatoryFields = mergeCategory.filter(
      (val) =>
        val?.mandatory === "Y" &&
        (val?.data_type === "from_year_to_year"
          ? val?.value?.from && val?.value?.to
          : val?.value),
    );

    const isMandatoryFieldsFilled =
      mandatoryFields.length === filledMandatoryFields.length;

    const isHyperlinkHave = mergeCategory?.some(
      (val) => val?.data_type === "hyperlink",
    );

    const isHyperlinkvalid = mergeCategory
      ?.filter((val) => {
        return val?.data_type === "hyperlink" && val?.value !== "";
      })
      .every((val) => isValidHttpUrl(val?.value));

    const isHyperLink = isHyperlinkHave && isHyperlinkvalid;

    switch (activeStep) {
      case 0:
        isStepValid =
          !!txnPayLoad?.ownerId &&
          !!txnPayLoad?.beneAccountId &&
          !!txnPayLoad?.selectedCategory;
        break;

      case 1:
        isStepValid =
          txnPayLoad?.date &&
          txnPayLoad?.expenseType?.length >=
            GlobalConfiguration.accountminLength &&
          !Array.isArray(txnPayLoad?.uploadFile) &&
          txnPayLoad?.uploadFile &&
          isMandatoryFieldsFilled &&
          (!isHyperlinkHave || isHyperLink);
        break;
      case 2:
        isStepValid = currentAccountDetails?.amount
          ? Number(currentAccountDetails?.amount) >=
              Number(txnPayLoad?.amount) &&
            isAmountValid &&
            isRtgsValid &&
            isSettleTypeValid
          : isAmountValid && isRtgsValid && isSettleTypeValid;
        break;

      case GlobalConfiguration.accountminLength:
        isStepValid = true;
        break;
      default:
        break;
    }

    BenEnableNextButton(!isStepValid);
  }, [activeStep, txnPayLoad, hyperLinks]);

  useEffect(() => {
    if (
      location?.state?.txnDetails?.reminderAmount !== "" &&
      txnPayLoad?.amount === "" &&
      location?.state !== null
    ) {
      let amountWords =
        AmountToWords(
          parseFloat(location?.state?.txnDetails?.reminderAmount),
        ) || "";
      setAmountInWords(
        location?.state?.txnDetails?.reminderAmount >=
          GlobalConfiguration.lengthCheckOne &&
          location?.state?.txnDetails?.reminderAmount <=
            GlobalConfiguration.accountnormalLength
          ? amountWords.replace("rupees", "rupee")
          : amountWords,
      );
      setTxnPayLoad((prev) => {
        return {
          ...prev,
          amount: location?.state?.txnDetails?.reminderAmount,
          amountInWords:
            location?.state?.txnDetails?.reminderAmount >=
              GlobalConfiguration.lengthCheckZero &&
            location?.state?.txnDetails?.reminderAmount <=
              GlobalConfiguration.accountnormalLength
              ? amountWords.replace("rupees", "rupee")
              : amountWords,
        };
      });
      setShowRupeeSymbol(true);
    }
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      setIsStepper(window.innerWidth <= ScreenSizeConfiguration.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > ScreenSizeConfiguration.mobileScreen) {
        setRefactorFlow(false);
      }
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // useEffect(() => {
  //
  //   dispatch(beneCategories());
  // }, [dispatch]);
  useEffect(() => {
    scrollIt.current.scrollTop = 0;
  }, [activeStep]);

  return (
    <div
      className={`w-width-full flex justify-start items-center flex-col bg-primary-bg ${openOwner || isModalOpen ? "overflow-y-hidden" : "overflow-y-auto"}`}
      style={{
        height:
          openOwner || isModalOpen
            ? "var(--full-height)"
            : "var(--full-height)",
      }}
    >
      <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
      <div className="bene_crt_reminder_header left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto bg-primary-nav-act Qsmd:bg-transparent rounded-border-radius-md">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>
      {isStepper && (
        <>
          <div className="flex items-center w-full-width h-mobile-create-header bg-primary-nav p-padding-sm top-top-base z-z-index-header shadow-box-shadow-bottom">
            <div
              className="cursor-pointer"
              onClick={() => {
                if (openBar) {
                  setOpenBar(false);
                } else {
                  navigate(-1);
                }
              }}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                color={"var(--text-primary)"}
                height={"var(--icon-md)"}
                width={"var(--icon-md)"}
                alt="Arrow"
              />
            </div>
            <div className="flex flex-col ml-margin-md">
              <div className="text-text-primary text-base">
                Reimbursement transaction
              </div>

              <div className="text-text-secondary text-xs">
                {steps[activeStep] || ""}
              </div>
            </div>
          </div>
        </>
      )}

      <div
        ref={scrollIt}
        className="overflow-y-auto overflow-x-hidden w-width-full pt-padding-lg h-full"
      >
        <div
          className={`max-w-tab-width-normal mx-auto scroll-smooth snap-x snap-mandatory w-width-full Qlg:w-max-content-width flex flex-col h-height-full Qsmd:pb-padding-base pb-padding-xl Qsmd:mb-margin-base mb-margin-md Qsmd:mt-margin-base Qsmd:pt-padding-base ${
            activeStep !== GlobalConfiguration.lengthCheckOne &&
            activeStep !== GlobalConfiguration.lengthCheckTwo &&
            activeStep !== GlobalConfiguration.accountminLength
              ? "pb-padding-xl"
              : ""
          }`}
        >
          <>
            <div
              className={`w-width-full h-height-full mb-margin-md ${
                activeStep === GlobalConfiguration.lengthCheckZero &&
                direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClass
              }`}
            >
              {renderCreateTxn()}
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default ReimburseCreateTxn;
